import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { NORMAL, PREMIUM } from "../../MyConst";
import { CalendarSvg, PassSvg } from "../../components/Assets";
import { ROUTE_PATHS } from "../../constants/Router";
import useHandleSaleLink from "../../hooks/useHandleSaleLink";
import formatDateToKorean from "../../utils/formatDateToKorean";
import str2date from "../../utils/str2date";

const Tmp = styled.div`
  padding: 6px 16px;
  background: var(--color-black-20);
  display: inline-block;
  width: fit-content;
`;
function RegistrationBanner() {
  const navigate = useNavigate();
  const mCeo = useSelector((state) => state.Ceo);
  const ceoType = mCeo?.ceoType;

  const { handleSaleLink } = useHandleSaleLink();

  if (ceoType === NORMAL) {
    const Trial = () => {
      return (
        <div className="flex gap-5" style={{ padding: "16px 20px 32px" }}>
          <img src={PassSvg} className="rounded-full img-size48"></img>
          <div className="flex flex-col gap-3">
            <p className="flex flex-col">
              <span className="text-white">
                간편 리뷰 관리, 스폰지R 프리미엄{" "}
              </span>
              {/* <span className="text-deadsea">가입 시 첫 달 무료!</span> */}
            </p>
            <Tmp onClick={handleSaleLink} className="text-white rounded-full">
              프리미엄 가입하기
            </Tmp>
          </div>
        </div>
      );
    };

    return <Trial />;
  }

  if (ceoType === PREMIUM) {
    const canceledPremium = mCeo?.canceledPremium || false;
    const estimatedCancelPremiumDttm = mCeo?.estimatedCancelPremiumDttm || null;
    if (canceledPremium && estimatedCancelPremiumDttm) {
      const Cancel = () => {
        return (
          <div className="flex gap-5" style={{ padding: "16px 20px 32px" }}>
            <img src={CalendarSvg} className="rounded-full img-size48"></img>
            <div className="flex flex-col gap-3">
              <p className="flex flex-col">
                <span className="text-white">
                  {formatDateToKorean(str2date(estimatedCancelPremiumDttm)) ??
                    " "}
                </span>
                <span className="text-white">
                  서비스 해지가 예정되어 있어요.
                </span>
              </p>
              <Tmp
                onClick={() => navigate(ROUTE_PATHS.CancelPremiumDeleteRequest)}
                className="text-white rounded-full"
              >
                해지 취소하기
              </Tmp>
            </div>
          </div>
        );
      };

      return <Cancel />;
    }
  }
  return <></>;
}

export default RegistrationBanner;
